import { SegmentKey } from '@amzn/fire-tv-campaign-automation-service';
import { STAGE } from 'src/constants';

import betaTargetSegments from '../data/TargetSegments/targetSegments_beta.json';
import gammaTargetSegments from '../data/TargetSegments/targetSegments_gamma.json';
import prodFeTargetSegments from '../data/TargetSegments/targetSegments_prod-fe.json';
import prodNaTargetSegments from '../data/TargetSegments/targetSegments_prod-na.json';

interface TargetingConfig {
  name: string;
  id: string;
}

export const targetSegmentConfiguration: Record<
  STAGE,
  Partial<Record<SegmentKey, TargetingConfig[]>>
> = {
  [STAGE.DEV]: betaTargetSegments as Partial<Record<SegmentKey, TargetingConfig[]>>,
  [STAGE.BETA]: betaTargetSegments as Partial<Record<SegmentKey, TargetingConfig[]>>,
  [STAGE.GAMMA]: gammaTargetSegments as Partial<Record<SegmentKey, TargetingConfig[]>>,
  [STAGE.PROD_NA]: prodNaTargetSegments as Partial<Record<SegmentKey, TargetingConfig[]>>,
  [STAGE.PROD_FE]: prodFeTargetSegments as Partial<Record<SegmentKey, TargetingConfig[]>>,
};
